<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>人员管理</el-breadcrumb-item>
      <el-breadcrumb-item>人员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="编辑人员">
      </el-page-header>
      <div class="panel-body form-horizontal">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <label class="col-md-4 control-label">姓名</label>
              <div class="col-md-8">
                <el-input :value="user.name" disabled></el-input>
              </div>
            </div>
            <div class="form-group" v-if="!user.is_super_admin">
              <label class="col-md-4 control-label">区域</label>
              <div class="col-md-8">
                <el-select
                  size="small"
                  placeholder="可多选"
                  v-model="user.regions"
                  multiple
                  class="long"
                >
                  <el-option
                    v-for="item in regions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id.toString()"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">人员层级</label>
              <div class="col-md-8">
                <el-select size="small" v-model="user.level" class="long">
                  <el-option :key="1" label="服务人员" :value="1"></el-option>
                  <el-option :key="2" label="大区" :value="2"></el-option>
                  <el-option :key="3" label="总部" :value="3"></el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">上级</label>
              <div class="col-md-8">
                <el-select size="small" v-model="user.parent_id" class="long">
                  <el-option key="0" label="无" :value="0"></el-option>
                  <el-option
                    v-for="item in parentUers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="col-md-8 col-md-offset-4">
              <el-button type="primary" size="small" @click="handlePost"
                >保存</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <input type="hidden" id="user-id" value="<%== @user.id %>" /> -->
  </div>
</template>


<script>
import {
  reportUserUpdate,
  regionList,
  reportUserList,
  reportUserDetail,
} from '../../../service/getData'
export default {
  data() {
    return {
      user: {},
      regions: [],
      parentUers: [],
    }
  },
  watch: {
    'user.level': 'getParentUers',
  },
  created() {
    this.getUserInfo()
    this.getRegions()
    this.getParentUers()
  },
  methods: {
    async handlePost() {
      let res = await reportUserUpdate(this.user)
      if (res.code == 0) {
        this.$router.go(-1)
      }
    },
    async getUserInfo() {
      let res = await reportUserDetail(this.$route.params.id)
      this.user = res.data
    },
    async getRegions() {
      let res = await regionList()
      this.regions = res.data.list
    },
    async getParentUers() {
      if (this.user.level) {
        let res = await reportUserList({
          level: this.user.level,
          page: 0,
          size: 50,
        })
        this.parentUers = res.data.list.filter(
          (item) => item.id != this.user.id
        )
      }
    },
  },
}
// $(function () {
//   let userId = $('#user-id').val()

//   $('#role-select').change(function () {
//     let role = $(this).val()
//     $.ajax({
//       url: '/admin/role_users',
//       dataType: 'json',
//       data: {
//         role: role,
//         user_id: userId,
//       },
//       success: function (json) {
//         if (json) {
//           str = "<option value=''>请选择</option>"
//           for (var i = json.length - 1; i >= 0; i--) {
//             str +=
//               "<option value='" + json[i][0] + "'>" + json[i][1] + '</option>'
//           }
//           $('select[name=parent_id]').html(str)
//         }
//       },
//     })
//   })
// })
</script>